/**
 * Process entry.
 *
 * The service worker is registered by `vite-plugin-pwa`'s injected script rather than
 * imported here, so this file has no dependency on a virtual module and the client's
 * `tsconfig` needs no extra `types` entry — which matters because that file is shared
 * with other chunks.
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.js';

const container = document.getElementById('root');
if (!container) throw new Error('#root is missing from index.html');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
